var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFilterOff = function SvgIconFilterOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.162 8.271 4.923-5.982H2.389l4.975 5.982a.83.83 0 0 1 .155.465v5.363l2.436 1.186v-6.6c0-.156.103-.31.207-.414Zm6.84-6.188-5.7 6.859v7.375c0 .515-.518.825-.933.618L6.586 15.13c-.207-.103-.414-.309-.414-.618v-5.57l-5.7-6.859C.109 1.67.42 1 .99 1h15.494c.57 0 .88.619.518 1.083Z",
    fill: "#1C4566",
    fillRule: "nonzero",
    stroke: "#1C4566",
    strokeWidth: 0.3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilterOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_filter_off.c7a0db30.svg";
export { ForwardRef as ReactComponent };